// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as IsPremiumLabel from "../../components/driver-records/views/IsPremiumLabel.bs.js";
import * as CrmRouteManager from "../../../../../to-be-migrated/routing/CrmRouteManager.bs.js";
import * as Navbar$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/navbar/Navbar.bs.js";
import * as ViewUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ViewUtils.bs.js";
import * as StringUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/StringUtils.bs.js";
import * as TicketsRequestMapper from "../../../../../ticket-dashboard/app/tickets/entitiy-mapper/TicketsRequestMapper.bs.js";
import * as OrderEligibilityStatusHelper from "../../components/driver-records/helper/OrderEligibilityStatusHelper.bs.js";

function getNavbarActions(msisdn, workspaceDispatch) {
  return {
          hd: {
            label: {
              TAG: /* Href */2,
              _0: "Raise Ticket",
              _1: CrmRouteManager.getRouteFromTab({
                    TAG: /* RaiseTicket */14,
                    _0: msisdn
                  })
            },
            on_select_cb: (function (param) {
                return Curry._2(workspaceDispatch.addTab, {
                            TAG: /* RaiseTicket */14,
                            _0: msisdn
                          }, false);
              }),
            icon: undefined
          },
          tl: {
            hd: {
              label: {
                TAG: /* Href */2,
                _0: "View Tickets",
                _1: CrmRouteManager.getRouteFromTab({
                      TAG: /* DriverTickets */16,
                      _0: msisdn
                    })
              },
              on_select_cb: (function (param) {
                  return Curry._2(workspaceDispatch.addTab, {
                              TAG: /* Tickets */42,
                              _0: TicketsRequestMapper.DictEncoder.execute({
                                    crn: undefined,
                                    case_number: undefined,
                                    caller_number: undefined,
                                    msisdn: msisdn,
                                    start_datetime: undefined,
                                    end_datetime: undefined,
                                    ticket_status: undefined,
                                    geo_region: undefined,
                                    raised_by: /* Partner */1
                                  })
                            }, false);
                }),
              icon: undefined
            },
            tl: {
              hd: {
                label: {
                  TAG: /* Href */2,
                  _0: "View Penalties",
                  _1: CrmRouteManager.getRouteFromTab({
                        TAG: /* DriverPenalties */18,
                        _0: msisdn,
                        _1: undefined
                      })
                },
                on_select_cb: (function (param) {
                    return Curry._2(workspaceDispatch.addTab, {
                                TAG: /* DriverPenalties */18,
                                _0: msisdn,
                                _1: undefined
                              }, false);
                  }),
                icon: undefined
              },
              tl: {
                hd: {
                  label: {
                    TAG: /* Href */2,
                    _0: "MBG Campaign",
                    _1: CrmRouteManager.getRouteFromTab({
                          TAG: /* MbgCampaignInfo */21,
                          _0: msisdn
                        })
                  },
                  on_select_cb: (function (param) {
                      return Curry._2(workspaceDispatch.addTab, {
                                  TAG: /* MbgCampaignInfo */21,
                                  _0: msisdn
                                }, false);
                    }),
                  icon: undefined
                },
                tl: /* [] */0
              }
            }
          }
        };
}

function make(param, partner_record_data) {
  var engagementType = param.engagementType;
  return {
          navbar_item_first: {
            label: "Name",
            value: {
              TAG: /* Text */0,
              _0: param.name
            }
          },
          navbar_item_second: {
            label: "",
            value: {
              TAG: /* Custom */1,
              _0: (function (param) {
                  return React.createElement(IsPremiumLabel.make, {});
                })
            }
          },
          navbar_item_third: {
            label: "Primary Contact",
            value: {
              TAG: /* Text */0,
              _0: param.primaryMobile
            }
          },
          navbar_item_fourth: {
            label: Belt_Option.mapWithDefault(engagementType, "", (function (param) {
                    return "Engagement Type";
                  })),
            value: Belt_Option.mapWithDefault(engagementType, /* NoText */0, (function (e_type) {
                    return {
                            TAG: /* Text */0,
                            _0: StringUtils$Catalyst.snakeCaseToTitleCase(e_type)
                          };
                  }))
          },
          navbar_item_fifth: {
            label: "",
            value: {
              TAG: /* Custom */1,
              _0: (function (param) {
                  return OrderEligibilityStatusHelper.getOrderEligibilityStatusView(OrderEligibilityStatusHelper.getOrderEligibilityStatus(partner_record_data));
                })
            }
          }
        };
}

function getView(msisdn, workspaceDispatch, partner_record_data) {
  var driverInfo = ViewUtils$Catalyst.extractLiveData(partner_record_data.driverInfo);
  if (driverInfo === undefined) {
    return React.createElement(Navbar$Catalyst.make, {
                title: "Partner Info",
                actions: getNavbarActions(msisdn, workspaceDispatch)
              });
  }
  var driverProfile = driverInfo.driverProfile;
  var match = make(driverProfile, partner_record_data);
  var navbar_item_fifth = match.navbar_item_fifth;
  var navbar_item_fourth = match.navbar_item_fourth;
  var navbar_item_third = match.navbar_item_third;
  var navbar_item_first = match.navbar_item_first;
  if (driverProfile.is_premium) {
    return React.createElement(Navbar$Catalyst.make, {
                title: "Partner Info",
                navbar_item_first: navbar_item_first,
                navbar_item_second: match.navbar_item_second,
                navbar_item_third: navbar_item_third,
                navbar_item_fourth: navbar_item_fourth,
                navbar_item_fifth: navbar_item_fifth,
                actions: getNavbarActions(msisdn, workspaceDispatch)
              });
  } else {
    return React.createElement(Navbar$Catalyst.make, {
                title: "Partner Info",
                navbar_item_first: navbar_item_first,
                navbar_item_third: navbar_item_third,
                navbar_item_fourth: navbar_item_fourth,
                navbar_item_fifth: navbar_item_fifth,
                actions: getNavbarActions(msisdn, workspaceDispatch)
              });
  }
}

export {
  getView ,
  
}
/* react Not a pure module */
